import { CARDTYPE_CONIG_CONSTANT } from '../constants/CardTypeConfigConstants';

const initialState = {
};

const CardTypeConfigReducer = (state = initialState, action) => {
    switch (action.type) {
        case CARDTYPE_CONIG_CONSTANT.LOAD_CARDTYPE_CONFIG:
            return {
                ...state,
                cardTypeConfig: action.payload.data
            };
        default:
            return state;
    }
};

export default CardTypeConfigReducer;